<template>
  <div v-if="story.publication_rules" class="m-10">
    <div class="m-b-40">
      <table v-if="!edit" class="table">
        <thead>
          <tr>
            <th>Section</th>
            <th>Poids</th>
            <th>Du</th>
            <th>Au</th>
          </tr>
        </thead>
        <tbody v-if="story.publication_rules.length == 0">
          <tr>
            <td colspan="4" class="text-center">
              <em class="text-muted">
                Pas de règle actuellement
              </em>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-for="rule in story.publication_rules">
            <td>
              <span v-if="rule.section">
                {{ rule.section | translate }}
              </span>
              <span v-else>Non précisé</span>
            </td>
            <td>
              {{ rule.weight }}
            </td>
            <td>
              {{ rule.start_at | formatDate('DD-MM-YYYY HH:mm') }}
            </td>
            <td>
              {{ rule.end_at | formatDate('DD-MM-YYYY HH:mm') }}
            </td>
          </tr>
        </tbody>
      </table>
      <table v-else class="table">
        <thead>
          <tr>
            <th>Section</th>
            <th>Poids</th>
            <th>Du</th>
            <th>Au</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="story.publication_rules.length == 0">
          <tr>
            <td colspan="4" class="text-center">
              <em class="text-muted">
                Pas de règle actuellement
              </em>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-for="(rule,key) in story.publication_rules">
            <td>
              <el-select
                clearable
                @change="updatePublicationRule('section', $event, key)"
                :value="rule.section">
                <el-option
                  v-for="(item,key) in constants.STORY_DISPLAY_SECTIONS"
                  v-if="item.rules_schemes.includes(story.scheme)"
                  :label="item.label"
                  :key="key"
                  :value="key">
                    {{ item.label }}
                </el-option>
              </el-select>
            </td>
            <td>
              <el-select
                @change="updatePublicationRule('weight', $event, key)"
                :value="rule.weight">
                <el-option
                  v-for="item in [0, 10, 20, 30, 50, 60, 70, 80, 90, 100]"
                  :label="item"
                  :key="item"
                  :value="item">
                    {{ item }}
                </el-option>
              </el-select>
            </td>
            <td>
              <el-date-picker
                :value="rule.start_at"
                @input="setDate($event, 'start_at', key)"
                type="datetime"
                format="dd-MM-yyyy HH:mm"
                placeholder="Choississez un jour">
              </el-date-picker>
            </td>
            <td>
              <el-date-picker
                :value="rule.end_at"
                @input="setDate($event, 'end_at', key)"
                type="datetime"
                format="dd-MM-yyyy HH:mm"
                placeholder="Choississez un jour">
              </el-date-picker>
            </td>
            <td class="text-right">
              <a href @click.prevent="deletePublicationRule(rule.id, key)" class="btn btn-warning btn-sm">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="edit" class="text-right">
      <a
        href
        @click.prevent="createPublicationRule()"
        class="btn btn-primary">
        <i class="fa fa-plus"></i>
        Ajouter une règle
      </a>
    </div>
    <!-- <pre>{{ story.publication_rules }}</pre> -->
    <!-- <pre>{{ constants.STORY_DISPLAY_SECTIONS }}</pre> -->
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'story-publication',
  computed: mapGetters({
    constants: 'constants',
    story: 'story',
    storyPublicationRule: 'storyPublicationRule'
  }),
  components: {},
  props: {
    parentInitFunction: Function,
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dirty: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {},
    createPublicationRule () {
      this.$store.dispatch('createStoryPublicationRule', {
        story_id: this.story.id,
        section: '',
        weight: 50,
        start_at: moment().minute(0).second(0).add(moment().utcOffset(), 'minutes').format(),
        end_at: moment().minute(0).second(0).add(moment().utcOffset(), 'minutes').format(),
        headers: {
          'X-Fields': 'id,publication_rules'
        }
      }).then(() => {
        let rules = JSON.parse(JSON.stringify(this.story.publication_rules))
        rules.unshift(this.storyPublicationRule)
        this.$store.commit('UPDATE_STORY_VALUE', {
          publication_rules: rules
        })
        this.$message({
          type: 'success',
          message: 'Règle crée avec succes'
        })
      })
    },
    deletePublicationRule (ruleId, key) {
      this.$confirm('Ceci effacera la règle. Continuer ?', 'Warning', {
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteStoryPublicationRule', {
          story_id: this.story.id,
          rule_id: ruleId,
          headers: {
            'X-Fields': 'id,publication_rules'
          }
        }).then(() => {
          let rules = JSON.parse(JSON.stringify(this.story.publication_rules))
          let sliced = rules.splice(key, 1)
          this.$store.commit('UPDATE_STORY_VALUE', {
            publication_rules: rules
          })
          this.$message({
            type: 'success',
            message: 'Règle supprimée'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Suppression annulée'
        })
      })
    },
    setDate (value, key, index) {
      value = moment(value).format('YYYY-MM-DDTHH:mm:00')
      this.updatePublicationRule (key, value, index)
    },
    updatePublicationRule (key, value, index) {
      let rules = JSON.parse(JSON.stringify(this.story.publication_rules))
      rules[index][key] = value
      this.$store.commit('UPDATE_STORY_VALUE', {
        publication_rules: rules
      })
    }
  }
}
</script>
<style>
</style>
